// correspond to event names in Amplitude dashboard
export enum AmpEvent {
	// canvassed shot
	shotChangeThumb = 'shift click shot thumb',
	shotChangeNext = 'next shot clicked',
	shotChangeTab = 'shot tab play shot',
	shotChangePrev = 'previous shot clicked',
	shotChangeFirstPlay = 'initial play shot clicked',
	shotChangeShowReset = 'show reset to not playing',
	// shots
	shotEditModalOpened = 'opened shot edit modal',
	// broadcasting
	recordStart = 'start recording',
	streamStart = 'start stream',
	recordCancel = 'cancel recording',
	streamCancel = 'cancel stream',
	// teleprompters
	shotNoteCreated = 'created shot note',
	shotNoteEdited = 'edited shot note',
	shotNoteViewed = 'viewed shot note',
	// notes
	noteCreated = 'created note',
	noteEdited = 'edited note',
	noteViewed = 'viewed note',
	// room state
	enteredShowbuilder = 'entered showbuilder',
	exitedShowbuilder = 'exited showbuilder',
	// trim
	clickedTrim = 'started trimming video',
	// chat
	chatMessageSent = 'sent chat message'
}

export enum AmpUserProp {
	userRole = 'user_role',
	email = 'email',
	roomId = 'room_id',
	roomSlug = 'room_slug', // the url code for the room
	channelId = 'channel_id', // the room's channel id
	eventsUUID = 'events_session_uuid', // the platform id for the session (sessions are part of larger :events:)
	roomTitle = 'room_title',
}
